import { render, staticRenderFns } from "./ViewKidsBirthDay.vue?vue&type=template&id=446395d4&scoped=true"
import script from "./ViewKidsBirthDay.vue?vue&type=script&lang=js"
export * from "./ViewKidsBirthDay.vue?vue&type=script&lang=js"
import style0 from "./ViewKidsBirthDay.vue?vue&type=style&index=0&id=446395d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446395d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('446395d4')) {
      api.createRecord('446395d4', component.options)
    } else {
      api.reload('446395d4', component.options)
    }
    module.hot.accept("./ViewKidsBirthDay.vue?vue&type=template&id=446395d4&scoped=true", function () {
      api.rerender('446395d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/birthdaymanagement/ViewKidsBirthDay.vue"
export default component.exports